import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loader: any = null;
  private showing = false;
  private requestId = 0;

  constructor(private _loaderCtrl: LoadingController) {}

  public async show(message?: string): Promise<any> {
    if (this.showing) {
      return true;
    }
    this.showing = true;
    this.requestId += 1;
    const requestId = this.requestId;
    const loader = await this._loaderCtrl.create({ message });
    if (requestId !== this.requestId) {
      await loader.dismiss();
      return true;
    }
    this._loader = loader;
    await loader.present();
    if (requestId !== this.requestId) {
      await loader.dismiss();
      if (this._loader === loader) {
        this._loader = null;
      }
    }
    return true;
  }

  public async hide() {
    this.showing = false;
    this.requestId += 1;
    const loader = this._loader;
    this._loader = null;
    try {
      if (loader) {
        await loader.dismiss();
      }
    } catch (err) {
      console.log(err);
    }
  }
}
